import { AxisLeft as VisxAxisLeft } from '@visx/axis';
import { tickLabelProps } from './styles';
import { Text } from '@visx/text';
import { useTranslation } from 'react-i18next';
import {
  MARGIN,
  MITARBEITER_THRESHOLD,
} from '@/domain/dienstplan/shared/utils/constants';
import { useVisualEditorContext } from '@/domain/dienstplan/features/VisualEditor/VisualEditorContext';

export function AxisLeft() {
  const { t } = useTranslation();
  const { yScaleAxis, maxMitarbeiterAnzahl } = useVisualEditorContext();
  const leftTickValues = Array.from(
    {
      length: maxMitarbeiterAnzahl.yAxisValue + MITARBEITER_THRESHOLD + 1,
    },
    (_, i) => i,
  );

  return (
    <>
      <VisxAxisLeft
        top={MARGIN.top}
        tickValues={leftTickValues}
        left={MARGIN.left}
        scale={yScaleAxis}
        tickFormat={(value) => Math.round(Number(value)).toString()}
        hideTicks
        tickLabelProps={tickLabelProps}
        stroke="#E5E5EA"
      />
      <Text
        x={17}
        y={MARGIN.top - 30}
        textAnchor="start"
        fontSize={15}
        fontWeight={600}
        fill="#000">
        {t(
          'domain.dienstplan.mindestbelegung.visualEditor.labels.anzahlMitarbeitende',
        )}
      </Text>
    </>
  );
}
